import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_SMC_LIST = "GET_SMC_LIST";
export const CREATE_SMC_USER = "CREATE_SMC_USER";
export const UPDATE_SMC_USER = "UPDATE_SMC_USER";
export const DELETE_SMC_USER = "DELETE_SMC_USER";

export const getSMCList = (page, rowsPerPage, data, id, search) => (dispatch) => { // get smc list data api
  axios.post(`/smcuser?page=${page}&size=${rowsPerPage}`, search, {
    headers: {
      filter_type: data,
      filter_code: id,
    }
  }).then((res) => {
    dispatch({
      type: GET_SMC_LIST,
      payload: res.data,
    });
  });
};

export const createSMCUser = (data) => (dispatch) => { // create smc user api call
  axios
    .post('/smcuser/create', data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: CREATE_SMC_USER,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const updateSMCUser = (id, data) => (dispatch) => { // update smc api
  axios
    .put(`/smcuser/${id}/update`, data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      localStorage.setItem("smcStatus", false)
      dispatch({
        type: UPDATE_SMC_USER,
        status: response.data.error,
      });
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const deleteSMCUser = (id) => (dispatch) => { // delete smc api
  axios.delete(`/smcuser/${id}/delete`).then((res) => {
    dispatch({
      type: DELETE_SMC_USER,
      payload: res.data,
    });
    dispatch(getSMCList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', 'success'));
  });
};

